export const blobResponseHandler = async (response: Response): Promise<Blob> => {
  const buffer = await response.arrayBuffer();
  return new Blob([buffer]);
};
